const LOGO = "https://assets.weimobtrade.com/20260212/997eb3f7e375ce03c7d534ac53fea4f7.png/source";

const PRODUCT_LINKS = [
  { label: "Sheet Metal Laser Cutting Machine", href: "#categories" },
  { label: "H-Beam Laser Cutting Machine", href: "#categories" },
  { label: "Laser Tube Cutting Machine", href: "#categories" },
  { label: "Laser Welding Machine", href: "#categories" },
  { label: "3D Laser Cutting Machine", href: "#categories" },
  { label: "Handheld Laser Welding and Cleaning System", href: "#categories" },
];

const QUICK_LINKS = [
  { label: "Industries", href: "#solutions", id: "footer-industries-link" },
  { label: "Case Studies", href: "#cases", id: "footer-cases-link" },
  { label: "About Us", href: "#about", id: "footer-about-link" },
  { label: "Videos", href: "https://www.youtube.com/@fiberlasercuttingmachine", id: "footer-videos-link", external: true },
  { label: "Contact", href: "#contact", id: "footer-contact-link" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#EDEEF0]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5">
            <img src={LOGO} alt="Penta Laser logo" className="h-9 w-9 object-contain" />
            <span className="text-lg font-bold uppercase tracking-tight text-navy">Penta Laser</span>
          </div>
          <p className="mt-3 text-sm font-semibold leading-snug text-[#333]">
            Laser Cutting & Welding Equipment Manufacturer
          </p>
          <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
            Supplied and supported in Australia from Hallam, Victoria.
          </p>
        </div>
        <div>
          <div className="text-sm font-bold uppercase tracking-wide text-navy">Products</div>
          <ul className="mt-4 space-y-2.5">
            {PRODUCT_LINKS.map((l, i) => (
              <li key={l.label}>
                <a href={l.href} data-testid={`footer-product-link-${i}`} className="text-[13px] text-muted-foreground transition-colors duration-150 hover:text-laser">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-sm font-bold uppercase tracking-wide text-navy">Quick Links</div>
          <ul className="mt-4 space-y-2.5">
            {QUICK_LINKS.map((l) => (
              <li key={l.id}>
                <a
                  href={l.href}
                  data-testid={l.id}
                  {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  className="text-[13px] text-muted-foreground transition-colors duration-150 hover:text-laser"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-sm font-bold uppercase tracking-wide text-navy">Contact Us</div>
          <ul className="mt-4 space-y-2.5 text-[13px] text-muted-foreground" data-testid="footer-contact">
            <li><a href="tel:+61404040920" className="transition-colors hover:text-laser">+61 404 040 920</a></li>
            <li><a href="mailto:sales@pentalaser.com.au" className="transition-colors hover:text-laser">sales@pentalaser.com.au</a></li>
            <li>18-20 Star Crescent,<br />Hallam VIC 3803, Australia</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#DCDDE0]">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-muted-foreground sm:px-8 md:flex-row md:items-center md:justify-between">
          <div>© {new Date().getFullYear()} Pentalaser Australia. All rights reserved.</div>
          <a href="#contact" data-testid="footer-legal-contact" className="uppercase tracking-wide transition-colors hover:text-laser">Legal - Contact Us</a>
        </div>
      </div>
    </footer>
  );
}
